import styled from 'styled-components';


const TituloCards = styled.p`
    text-transform: capitalize;
    font-size: 1em;
    margin: 15px 20px;
    font-weight: bold;
    
     @media (max-width: 350px) {
        font-size: 0.9em;
    }
`;


export default TituloCards;
